module.exports = __webpack_public_path__ + "img/white-plus.2f71cda9.svg";